var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-collapse",
    {
      model: {
        value: _vm.membroId,
        callback: function($$v) {
          _vm.membroId = $$v
        },
        expression: "membroId"
      }
    },
    _vm._l(_vm.membros, function(membro, index) {
      return _c(
        "el-collapse-item",
        { key: index, attrs: { title: membro.nome, name: index } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: { label: "Nome:", content: membro.nome }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Data de Nascimento:",
                      content: _vm.formatDate(
                        membro.dataNascimento,
                        "DD/MM/YYYY"
                      )
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Sexo:",
                      content: _vm.formataTexto(membro.sexo)
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Estado civil:",
                      content: _vm.formatarEstadoCivil(membro.estadoCivil)
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Profissão:",
                      content: _vm.valorCampo(membro.profissao)
                    }
                  })
                ],
                1
              ),
              membro.renda
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Renda:",
                          content: _vm.exibirValor(membro.renda, "renda")
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              membro.rendaMembro
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Renda:",
                          content: _vm.formatRenda(membro.rendaMembro)
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-row",
            [
              membro.tempoMoradia
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Tempo moradia:",
                          content: _vm.valorCampo(membro.tempoMoradia)
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Programa Social:",
                      content: _vm.valorCampo(membro.programaSocial)
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Observações referentes à renda:",
                      content: _vm.valorCampo(membro.observacoesRenda)
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c8c4be3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c8c4be3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppMembroFamiliaComparar.vue
// module id = null
// module chunks = 